import { createFileRoute } from "@tanstack/react-router";
import CreditNotesConfigurations from "@/components/invoices/credits/configuration/credit-notes-configuration";
import InvoicesConfigurationNavigation from "@/components/invoices/configuration/invoices-configuration-navigation";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";

export const Route = createFileRoute(
  "/_authenticated/settings/_layout/invoices/credit-notes",
)({
  component: CreditNotesSettingsPage,
});

function CreditNotesSettingsPage() {
  return (
    <RouteGuardPermissions
      permissions={[
        { module: "credit_notes_configurations", actions: ["read", "update"] },
      ]}
    >
      <div className="gap-4 flex-col flex">
        <InvoicesConfigurationNavigation />
        <CreditNotesConfigurations module="credit_notes_configurations" />
      </div>
    </RouteGuardPermissions>
  );
}
